import React, { useState, useEffect } from 'react';
import { TextField, Button, Typography, Paper } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import FileBase from 'react-file-base64';
import { create } from 'jss';
import rtl from 'jss-rtl';
import { StylesProvider, jssPreset } from '@material-ui/core/styles';
import validator from 'validator';
import DeleteIcon from "@material-ui/icons/Delete";
import SendIcon from '@material-ui/icons/Send';
import useStyles from './styles';
import { createPost } from '../../actions/posts';

const Form = ({ currentId, setCurrentId }) => {
  const [postData, setPostData] = useState({ creator: '', title: '', message: '', tags: '', selectedFile: '',link: '' });
  const post = useSelector((state) => (currentId ? state.posts.find((message) => message._id === currentId) : null));
  const dispatch = useDispatch();
  const classes = useStyles();
  const jss = create({ plugins: [...jssPreset().plugins, rtl()] });

  
  useEffect(() => {
    if (post) setPostData(post);
  }, [post]);

  const clear = () => {
    setCurrentId(0);
    setPostData({ creator: '', title: '', message: '', tags: '', selectedFile: '',link: '' });
  };

  const handleSubmit = async (e) => {

    if(!postData.title&&!postData.message&&!postData.link&&!postData.tags)
      {
        alert("השדות המסומנים ב-* הינם שדות חובה");
        return false;
      }
      if (!validator.isURL(postData.link)) {
        alert('כתובת לא חוקית')
        return false;
  
      }
    
    e.preventDefault();

    if (currentId === 0) {
      dispatch(createPost(postData));
      clear();
    } else {
      clear();
    }
  };

  return (

    <StylesProvider jss={jss}>
    <div dir="rtl">

    <Paper className={classes.paper}   >
      <form autoComplete="off" noValidate className={`${classes.root} ${classes.form}`} onSubmit={handleSubmit} >
        <Typography variant="h6">{currentId ? `Editing "${post.title}"` : ' הוסף קבוצה למאגר'} </Typography>
        <TextField  name="creator"   label="נוסף למאגר על ידי" fullWidth value={postData.creator} onChange={(e) => setPostData({ ...postData, creator: e.target.value })} />
        <TextField  name="title"  FormHelperTextProps={{className: classes.helperText }} helperText="שם הקבוצה של הרשת חברתיתית-שדה חובה (*)"label="שם הקבוצה"  fullWidth value={postData.title} onChange={(e) => setPostData({ ...postData, title: e.target.value })} />
        <TextField name="message" FormHelperTextProps={{className: classes.helperText }} helperText="יש להוסיף תיאור מלא של הקבוצה-שדה חובה (*)" label="תיאור הקבוצה" fullWidth multiline rows={4} value={postData.message} onChange={(e) => setPostData({ ...postData, message: e.target.value })} />
        <TextField name="tags" FormHelperTextProps={{className: classes.helperText }}  helperText="יש לציין את המוסד אקדמאי של הקבוצה-שדה חובה (*)" label="מוסד אקדמי" fullWidth value={postData.tags} onChange={(e) => setPostData({ ...postData, tags: e.target.value.split(',') })} />

        <TextField  name="link" FormHelperTextProps={{className: classes.helperText }}  helperText="יש להוסיף לינק הצטרפות של הקבוצה-שדה חובה (*)"  label="לינק לרשת חברתית" fullWidth value={postData.link} onChange={(e) => setPostData({ ...postData, link: e.target.value })} />
        <div className={classes.fileInput} >
        <FileBase  type="file" multiple={false} onDone={({ base64 }) => setPostData({ ...postData, selectedFile: base64 })} /> <p className={classes.helperFile} >
        הוסף תמונה (במידה ולא תבחר תמונה תבחר אוטומטית ממאגר)            </p></div>
        <Button className={classes.buttonSubmit}   variant="contained" color="primary" endIcon={<SendIcon />} type="submit" fullWidth>  שלח  &nbsp;</Button> &nbsp;
        <Button variant="contained" color="secondary" size="small" endIcon={<DeleteIcon />}  onClick={clear} fullWidth> נקה &nbsp;</Button>                   

      </form>
    </Paper></div>
    </StylesProvider>    


  );
};

export default Form;
